import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import zhCommon from './locales/zh/common.json';
import enLanding from './locales/en/landing.json';
import zhLanding from './locales/zh/landing.json';
import enAuth from './locales/en/auth.json';
import zhAuth from './locales/zh/auth.json';
import enTickets from './locales/en/tickets.json';
import zhTickets from './locales/zh/tickets.json';
import enDashboard from './locales/en/dashboard.json';
import zhDashboard from './locales/zh/dashboard.json';
import enFooter from './locales/en/footer.json';
import zhFooter from './locales/zh/footer.json';
import enStatic from './locales/en/static.json';
import zhStatic from './locales/zh/static.json';

const resources = {
  en: { 
    common: enCommon,
    landing: enLanding,
    auth: enAuth,
    tickets: enTickets,
    dashboard: enDashboard,
    footer: enFooter,
    static: enStatic,
  },
  zh: { 
    common: zhCommon,
    landing: zhLanding,
    auth: zhAuth,
    tickets: zhTickets,
    dashboard: zhDashboard,
    footer: zhFooter,
    static: zhStatic,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    defaultNS: 'common',
    ns: ['common','landing','auth','tickets','dashboard','footer','static'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// keep <html lang> in sync
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

export default i18n;
